import { DateTime } from "luxon";

import { type TimePeriod } from "@utils/chart-data-conversions/timelines";

import type {
  PlayerActivity,
  MightierGameKey,
} from "@neuromotion-inc/mightier-ts-sdk";

export const extractPlayerActivityForTimePeriod = (
  activity: PlayerActivity[],
  start: DateTime,
  end: DateTime,
): PlayerActivity[] => {
  return activity.filter((activity) => {
    const timestamp = DateTime.fromISO(activity.period_datetime);
    return timestamp >= start && timestamp <= end;
  });
};

export interface GameStat {
  gameKey: MightierGameKey;
  secondsPlayed: number;
  numCooldowns: number;
}

export const extractStatsPerGame = (activity: PlayerActivity[]): GameStat[] => {
  const ret: GameStat[] = [];

  activity.forEach((activity) => {
    activity.games_played.forEach((gp) => {
      const currentIdx = ret.findIndex((stat) => stat.gameKey === gp.game_name);
      // ret[currentIdx] being falsy means we haven't seen current gameKey yet.. need to push onto array
      if (ret[currentIdx]) {
        ret[currentIdx].secondsPlayed += gp.seconds_played;
        ret[currentIdx].numCooldowns += gp.num_cooldowns;
      } else {
        ret.push({
          gameKey: gp.game_name,
          secondsPlayed: gp.seconds_played,
          numCooldowns: gp.num_cooldowns,
        });
      }
    });
  });

  // sort desc- most playtime at the top
  return ret.sort((a, b) => b.secondsPlayed - a.secondsPlayed);
};

function _tsExhaustivenessCheck(value: never): never {
  throw new Error(`Unhandled case: ${JSON.stringify(value)}`);
}

export const formatTimePeriodForChartLabel = (tp: TimePeriod): string => {
  if (tp.granularity === "day") {
    return tp.start.toFormat("LLL d");
  }
  if (tp.granularity === "week") {
    return tp.start.toFormat("LLL d");
  }
  if (tp.granularity === "month") {
    return tp.start.toFormat("LLL");
  }

  _tsExhaustivenessCheck(tp.granularity);
};
